"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchPageDynamic = void 0;
var Autocomplete_1 = require("./Autocomplete");
var I18n_1 = require("./I18n");
var SearchPageDynamic = /** @class */ (function () {
    function SearchPageDynamic(lang) {
        var _this = this;
        this.lang = lang;
        var self = this;
        this.i18n = new I18n_1.I18n(this.lang);
        this.form = document.getElementById('search-form');
        this.form.addEventListener('submit', function (event) {
            event.preventDefault();
            event.stopPropagation();
            self.doSearch();
        });
        this.searchUrl = this.form.action;
        this.searchTabResultPanel = document.getElementById('search-tab-result-panel');
        this.liveRegion = this.createLiveRegion();
        this.queryInput = new Autocomplete_1.Autocomplete(this.i18n.getProperty('Suche', 'Suche'), function (query) {
            return __awaiter(this, void 0, void 0, function () {
                var queryParts, queryString, url, response, data, jsonResults, autoCompleteValues, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(query.length > 0)) return [3 /*break*/, 5];
                            queryParts = query.split(/\s+/);
                            queryString = queryParts.pop() || '';
                            if (!queryString.trim())
                                queryString = queryParts.pop() || '';
                            url = new URL(self.autocompleteUrl, window.location.href);
                            url.searchParams.set('q', queryString);
                            url.searchParams.set('lang', self.lang);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 4, , 5]);
                            return [4 /*yield*/, fetch(url.toString())];
                        case 2:
                            response = _a.sent();
                            if (!response.ok)
                                throw new Error("Request failed with status ".concat(response.status));
                            return [4 /*yield*/, response.json()];
                        case 3:
                            data = _a.sent();
                            jsonResults = data.suggestions || data.autocomplete_terms;
                            autoCompleteValues = jsonResults.map(function (suggestion) { return ({ key: suggestion, value: suggestion }); });
                            self.queryInput.showDataWithTopResults(autoCompleteValues, data.top_results);
                            return [3 /*break*/, 5];
                        case 4:
                            error_1 = _a.sent();
                            self.queryInput.showData([]);
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        }, document.getElementById('search-query'), 1, false);
        this.queryInput.setI18n(this.i18n);
        this.queryInput.setCloseListenerForPanel();
        self.queryInput.inputElement.addEventListener('change', function (e) {
            if (self.queryInput.isPanelVisible()) {
                e.preventDefault();
                return;
            }
        });
        this.autocompleteUrl = self.queryInput.inputElement.getAttribute('data-autocomplete-url');
        self.queryInput.inputElement.value = decodeURI(location.hash.replace('#', ''));
        if (location.hash)
            self.doSearch();
        setTimeout(function () {
            _this.queryInput.inputElement.focus();
        }, 100);
    }
    SearchPageDynamic.prototype.doSearch = function () {
        return __awaiter(this, void 0, void 0, function () {
            var self, url, response, data, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        self = this;
                        location.hash = self.queryInput.inputElement.value;
                        this.queryInput.inputElement.focus();
                        if (!(self.queryInput.inputElement.value.length > 0)) return [3 /*break*/, 5];
                        url = new URL(self.searchUrl, window.location.href);
                        url.searchParams.set('q', self.queryInput.inputElement.value);
                        url.searchParams.set('lang', self.lang);
                        self.queryInput.closeAllPanels();
                        self.showLoading();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch(url.toString())];
                    case 2:
                        response = _a.sent();
                        if (!response.ok)
                            throw new Error("Request failed with status ".concat(response.status));
                        return [4 /*yield*/, response.json()];
                    case 3:
                        data = _a.sent();
                        self.renderResults(data);
                        return [3 /*break*/, 5];
                    case 4:
                        error_2 = _a.sent();
                        console.error('Search request failed', error_2);
                        self.hideLoading();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    SearchPageDynamic.prototype.showLoading = function () {
        var loadingText = this.i18n.getProperty('search.loading', 'Suchergebnisse werden geladen ...');
        this.searchTabResultPanel.innerHTML = "<oebbx-loader class=\"search-loading\">".concat(loadingText, "</oebbx-loader>");
        this.searchTabResultPanel.style.display = 'block';
        this.announce(loadingText);
    };
    SearchPageDynamic.prototype.hideLoading = function () {
        this.searchTabResultPanel.innerHTML = '';
        this.searchTabResultPanel.style.display = 'none';
    };
    SearchPageDynamic.prototype.renderResults = function (response) {
        this.searchTabResultPanel.innerHTML = '';
        if (!response || response.length === 0) {
            this.searchTabResultPanel.style.display = 'none';
            this.announce(this.i18n.getProperty('search.noResults', 'Keine Suchergebnisse gefunden'));
            return;
        }
        var tabs = document.createElement('oebbx-tabs');
        var totalHits = 0;
        for (var _i = 0, response_1 = response; _i < response_1.length; _i++) {
            var group = response_1[_i];
            var hits = group.hits || [];
            totalHits += hits.length;
            var tabItem = document.createElement('oebbx-tab-item');
            tabItem.setAttribute('label', "".concat(group.label, " (").concat(hits.length, ")"));
            var holderDiv = document.createElement('div');
            tabItem.appendChild(holderDiv);
            var resultList = document.createElement('ul');
            holderDiv.appendChild(resultList);
            for (var _a = 0, hits_1 = hits; _a < hits_1.length; _a++) {
                var hit = hits_1[_a];
                var liElement = document.createElement('li');
                liElement.classList.add('search-result-item');
                var aElement = document.createElement('a');
                aElement.href = hit.url;
                aElement.innerHTML = "\n                    <h2 class=\"search-result-item__title\">\n                        ".concat(hit.title, "\n                        <span>").concat(hit.url.indexOf('.pdf') > -1 ? 'PDF' : this.i18n.getProperty('type.page', 'Seite'), "</span>\n                    </h2>\n                    <p>").concat(hit.content, "</p>\n                    <p>").concat(hit.displayUrl, "</p>\n                ");
                liElement.appendChild(aElement);
                resultList.appendChild(liElement);
            }
            tabs.appendChild(tabItem);
        }
        this.searchTabResultPanel.appendChild(tabs);
        this.searchTabResultPanel.style.display = 'block';
        if (totalHits === 0) {
            this.announce(this.i18n.getProperty('search.noResults', 'Keine Suchergebnisse gefunden'));
        }
        else if (totalHits === 1) {
            this.announce(this.i18n.getProperty('search.resultFound', '1 Suchergebnis gefunden'));
        }
        else {
            this.announce(this.i18n.getProperty('search.resultsFound', '{0} Suchergebnisse gefunden').replace('{0}', String(totalHits)));
        }
    };
    SearchPageDynamic.prototype.createLiveRegion = function () {
        var region = document.createElement('div');
        region.className = 'screen-reader-text';
        region.setAttribute('role', 'status');
        region.setAttribute('aria-live', 'polite');
        (document.getElementById('search-page-dynamic') || document.body).appendChild(region);
        return region;
    };
    // Clear first so screen readers re-announce identical consecutive messages.
    SearchPageDynamic.prototype.announce = function (message) {
        var _this = this;
        this.liveRegion.textContent = '';
        window.setTimeout(function () {
            _this.liveRegion.textContent = message;
        }, 100);
    };
    return SearchPageDynamic;
}());
exports.SearchPageDynamic = SearchPageDynamic;
